import React, { memo } from 'react';

import { useTranslation } from 'react-i18next';

import Alert, { ALERT_TYPE } from '@/views/alerts/Alert';

const WaitForVerification = props => {
  const { email } = props;
  const { t } = useTranslation();

  return (
    <Alert
      type={ALERT_TYPE.WARNING}
      message={t('alert.wait-for-verification.title')}
      description={t('alert.wait-for-verification.description', { email })}
    />
  );
};

export default memo(WaitForVerification);
